export default "__VITE_ASSET__Clcp1yt7__"